var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle, _path17, _rect, _path18, _ellipse, _path19, _path20, _g, _rect2, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformaciondecontactoCenfotec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_8",
    "data-name": "Layer 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 532.75 583.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-22{fill:#9cc8ff;}.cls-2{fill:#ebf6fc;}.cls-3{fill:#acd7ea;stroke:#214c69;}.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-3,.cls-4,.cls-9{stroke-miterlimit:10;}.cls-4,.cls-6{fill:#00479b;}.cls-4{stroke:#9ec6de;}.cls-5{fill:#abd5ef;}.cls-7{fill:url(#linear-gradient);}.cls-8{fill:url(#linear-gradient-2);}.cls-9{fill:#ffe28e;stroke:#ffe28e;}.cls-10{fill:#deb87d;}.cls-11{fill:url(#radial-gradient);}.cls-12,.cls-18{fill:#d1d4d4;}.cls-13{fill:url(#linear-gradient-3);}.cls-14{fill:#ffdba3;}.cls-15{fill:#333;}.cls-16{fill:#ffeab9;}.cls-17,.cls-19,.cls-21{fill:#006aea;}.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23{stroke:#fff;}.cls-17,.cls-18{stroke-width:3px;}.cls-19,.cls-20{stroke-width:2px;}.cls-20,.cls-23{fill:none;}.cls-21{stroke-width:6px;}.cls-22,.cls-23{stroke-width:5px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 950.43,
    y1: 320.5,
    x2: 1003.34,
    y2: 320.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a4cff7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#a1cdf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#99c8f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#8abff7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#75b2f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65a8f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 938.32,
    y1: 369.4,
    x2: 1020.51,
    y2: 369.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#abd5ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#a8d3ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#a0ceef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#91c5ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#7cb7ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#60a6ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#3f92ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e87ec"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 979.33,
    cy: 284.15,
    r: 14.6,
    gradientTransform: "matrix(1, 0, 0, 1.07, -0.32, -23.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#ffeab9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ffe7b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#ffdda3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#ffd99c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ffd394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcd8c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1060.5,
    y1: 485.18,
    x2: 997.13,
    y2: 292.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#006aea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#abd5ef"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M904.41,185c1.59,64.59-57.95,139.42-100.7,145.31-42.38,5.84-43.19-61-103.31-72.4-52.43-9.93-88.81,29.71-99.91,7-12.33-25.24,17.76-104.49,53.58-123.52,29.6-15.72,41.63,21.07,81.72,6,29.94-11.27,34.62-28.69,60.9-38.34C840.18,93.07,902.8,120.14,904.41,185Z",
    transform: "translate(-534.94 -104.56)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M826.81,239.37C852.55,281.53,757.31,434,650.6,426.73c-58-4-120.29-55.25-115.39-97.59,4.51-39,64.78-59.74,114.86-77C664.52,247.19,802.57,199.67,826.81,239.37Z",
    transform: "translate(-534.94 -104.56)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M885.76,433",
    transform: "translate(-534.94 -104.56)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M959.28,647.37l-36.37-.25c-.67-6.8-1.59-16.59-2.55-28.4-2.07-25.69-3.11-38.54-2.74-49.33.28-8.32.7-6.48,4.69-44.32,1.57-14.87,2.16-21.38,2.71-26.62,1.75-16.64,5.23-40.95,12.9-73.76L985.31,422c3.74,34.81-1.07,58.18-6.55,73.46-2.57,7.18-6.49,15.94-8.79,30.09-3,18.18.75,20.79-.3,41.45-.72,14.26-2.82,19.57-6.25,36.72-2.57,12.84-4.22,19.32-4.63,26.69A102.23,102.23,0,0,0,959.28,647.37Z",
    transform: "translate(-534.94 -104.56)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M948.69,305.08h0c8.58,3.89,12.54,15.1,8.85,25l-23.79,64c-3.69,9.93-13.64,14.83-22.22,10.94h0c-8.58-3.89-12.55-15.09-8.86-25l23.79-64C930.15,306.09,940.1,301.19,948.69,305.08Z",
    transform: "translate(-534.94 -104.56)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M954.88,291.42A24.31,24.31,0,0,1,966.13,301a25.93,25.93,0,0,1,3.74,12.78,38.36,38.36,0,0,1-1.6,11.84c-.29.91-.54,1.81-.85,2.69s-.62,1.74-1,2.59l-.54,1.26-.27.62-.13.31-.11.22-.86,1.77-13.8,28.27-6.87,14.15c-2.23,4.74-4.5,9.47-6.7,14.22-.56,1.2-1,2.34-1.67,3.6a24.73,24.73,0,0,1-2.16,3.69,21.23,21.23,0,0,1-6.17,5.74,17.23,17.23,0,0,1-7.91,2.53,16.35,16.35,0,0,1-8-1.58,17.66,17.66,0,0,1-6.15-5.15,20.92,20.92,0,0,1-3.43-7.17,22.39,22.39,0,0,1-.59-7.9c.09-.65.15-1.32.28-2s.27-1.3.46-1.93c.39-1.28.83-2.51,1.26-3.73a178.38,178.38,0,0,0,7.79-30.51c1.79-10.47,2.88-21.2,4.46-31.75l.32-2,.16-1,.07-.5.19-.7a29.65,29.65,0,0,1,10.27-16,27.89,27.89,0,0,1,13.26-5.83c.63-.1,1.27-.19,1.91-.26s1.29-.06,1.94-.07a24.46,24.46,0,0,1,3.91.2,13.61,13.61,0,0,1,1.93.3c.64.14,1.28.28,1.92.44C952.45,290.53,953.66,291,954.88,291.42Zm-12.39,27.33c0-.18.16-.36,0-.64s-.2-.23-.42-.37a2.85,2.85,0,0,0-.86-.11,5.29,5.29,0,0,0-2.59,1,9.58,9.58,0,0,0-1.43,1.21,1.7,1.7,0,0,0-.2.19l-.26.43-.52.85-1,1.69c-5.69,9-11.87,17.86-17.35,27a178.76,178.76,0,0,0-14,28.19,25.57,25.57,0,0,0-2.06,7.43,20,20,0,0,0,.63,7.63,16.92,16.92,0,0,0,9.42,11.28,13.87,13.87,0,0,0,13.87-1.93,16.63,16.63,0,0,0,4.6-5.45,17.86,17.86,0,0,0,1.37-3.29c.37-1.16.73-2.48,1.09-3.72,1.44-5,2.8-10.09,4.21-15.14l4-15.2,8-30.43.5-1.9.06-.24,0-.15,0-.31.06-.6a8.31,8.31,0,0,0-.06-1.22,9.21,9.21,0,0,0-.28-1.18,7.24,7.24,0,0,0-2.82-3.68,6.54,6.54,0,0,0-3.15-1.15C942.63,318.81,942.48,319,942.49,318.75Z",
    transform: "translate(-534.94 -104.56)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M913.21,389.13h0c-3.86,1.62-8.49-3.33-10.34-11.06L889.16,320.7c-1.85-7.72-.22-15.29,3.64-16.91h0c3.86-1.61,8.49,3.34,10.33,11.06l13.72,57.38C918.7,380,917.07,387.52,913.21,389.13Z",
    transform: "translate(-534.94 -104.56)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M918.82,402.5a24.62,24.62,0,0,1-3.25,1.16,22.56,22.56,0,0,1-3.5.53,21.44,21.44,0,0,1-3.4-.11,23.18,23.18,0,0,1-3-.61,23.9,23.9,0,0,1-8.32-4.35l-1.41-1.2c-.42-.39-.8-.77-1.2-1.17l-.59-.59-.51-.58-1-1.16a34.13,34.13,0,0,1-3.06-4.58c-.42-.77-.82-1.53-1.14-2.29a21.74,21.74,0,0,1-.92-2.28,22.47,22.47,0,0,1-.73-2.29l-.16-.57-.13-.51-.16-.72a51.78,51.78,0,0,1-.91-5.84c-.9-7.86-1.35-15.83-1.52-23.87s0-16.14,0-24.21v-4.54l0-1.65a35.38,35.38,0,0,1,.53-7,24.65,24.65,0,0,1,2.15-6.71,12.92,12.92,0,0,1,2.09-3.14,8,8,0,0,1,3.45-2.36,5.93,5.93,0,0,1,4.23.24,8.65,8.65,0,0,1,2.87,2.15,17.44,17.44,0,0,1,3.19,5.47,34.23,34.23,0,0,1,1.59,5.82c.37,1.93.8,3.85,1.24,5.76a113.24,113.24,0,0,0,7.74,22.38c1.68,3.63,3.59,7.21,5.54,10.78l6,10.69,1.49,2.67.75,1.33.36.68.4.95a33.15,33.15,0,0,1,2.3,8.17,26.83,26.83,0,0,1-.29,9.94,21.67,21.67,0,0,1-.9,3c-.2.53-.48,1.12-.74,1.67-.14.29-.25.55-.42.85l-.55.92a14,14,0,0,1-1.28,1.83c-.26.32-.53.64-.8.95a11.2,11.2,0,0,1-.91.93,20.85,20.85,0,0,1-2.21,1.83A24.45,24.45,0,0,1,918.82,402.5ZM907.6,375.77a7.09,7.09,0,0,0-1.46.9,7.29,7.29,0,0,0-1,.94l-.37.43a3.79,3.79,0,0,0-.3.4,4.69,4.69,0,0,0-.38.69c0,.1-.08.21-.11.31a.82.82,0,0,0-.06.22,1.21,1.21,0,0,0,0,.37c0,.13.08.31.18.3s.47-.15.74-.42a7.91,7.91,0,0,0,.76-1.24,15.75,15.75,0,0,0,1.11-3.51l.09-.5,0-.76.06-1.52.12-3.06.51-12.24c.12-4.06.21-8.12.07-12.13a113,113,0,0,0-3.22-23.45c-.47-1.91-1-3.81-1.5-5.7a23.07,23.07,0,0,0-2.09-5.35,17.68,17.68,0,0,0-1.55-2.32,11.12,11.12,0,0,0-1.93-1.84,5.24,5.24,0,0,0-2.08-.94,1.94,1.94,0,0,0-1.53.38,5.48,5.48,0,0,0-1.47,3.55,14.56,14.56,0,0,0,.38,4.88,19.32,19.32,0,0,0,1.72,4.7l2.64,5.28c3.65,7.2,7.44,14.37,10.92,21.61s6.68,14.55,9.44,22a54.16,54.16,0,0,1,1.83,5.62l.18.72a1.45,1.45,0,0,0,.06.19l0,.14.1.54c0,.18,0,.35.06.49a3.22,3.22,0,0,1,0,.43.74.74,0,0,1-.2.56l-.13,0-.08,0-.11,0c-.07,0-.15,0-.24-.06a2.26,2.26,0,0,0-.35-.17,14.39,14.39,0,0,0-3.36-1.25,11.26,11.26,0,0,0-3.56-.26,8.09,8.09,0,0,0-2,.37A7.72,7.72,0,0,0,907.6,375.77Z",
    transform: "translate(-534.94 -104.56)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1054.43,642.53l-39.69,14.06c-2-4.28-4.67-10.2-7.54-17.38-4.76-11.92-13.07-33-17.58-59.61-3.84-22.63-1.1-26.61-6.56-46.42-3.33-12-6.82-19.55-9.07-25.12-6.3-15.58-12.47-39.7-10.64-76.18l50.21-19.13c3.94,14,12.5,45.36,17.39,73.69,1.08,6.24,2.06,11.95,2.89,19.95,2.23,21.38-.36,23.36,2.08,36.7,2.09,11.4,4,9.86,9.45,31.06.53,2.05,2.81,11,5.06,22.89,1.89,10,3.28,17.52,3.89,27.53A162.51,162.51,0,0,1,1054.43,642.53Z",
    transform: "translate(-534.94 -104.56)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M988.53,271c0,7.47-12.17,11.51-14.14,12.18-6.24,2.09-13.38,1.5-14.15-1.85-.17-.75.11-1.07.24-3.67a52.11,52.11,0,0,0-.23-6.66c-.06-4.88,6.88-12.17,14.14-12.17C982.2,258.82,988.53,264.27,988.53,271Z",
    transform: "translate(-534.94 -104.56)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M976.26,283.68c7.35-.47,11.29-5.45,12.27-5.42a13.89,13.89,0,0,1,7.54,2.49,10.85,10.85,0,0,1,2.6,2.77,16.42,16.42,0,0,1,1.43,3.46c1,2.41,2.34,10.81,3,23.63.33,6.63.33,14.18,0,22.42-.31,8.39-1,17.41-1.57,26.87a63.52,63.52,0,0,1-10,2.25,66.61,66.61,0,0,1-14.77.36c-11.85-.91-21.85-4-25.75-7.81-.64-1.55-.65-4.14-.55-8.84.13-5.16.17-10.53.41-16.11.48-11.6,2.43-26.35,3.41-40.72.32-4.72,4.52-8.83,9.88-9.41C965,279.68,969.27,284.14,976.26,283.68Z",
    transform: "translate(-534.94 -104.56)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M955.59,299.31A24.56,24.56,0,0,0,976,308.05c12.8-.93,18.86-11.21,19.17-11.76a18.13,18.13,0,0,1,12.29,3.67,15.29,15.29,0,0,1,4,4.72,15.13,15.13,0,0,1,1.73,5.95c.21,2.41,1.07,16.61,2.37,39.11.65,11.25,1.41,24.58,2.25,39.55s1.77,31.57,2.75,49.37A102.07,102.07,0,0,1,977,441.37a100.06,100.06,0,0,1-37.37-13.78c-2.17-4.67-1.28-19.43-.28-39.56s2.09-45.64.32-71.81C939.12,307.59,946.23,300,955.59,299.31Z",
    transform: "translate(-534.94 -104.56)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1038.29,239.26",
    transform: "translate(-534.94 -104.56)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1054.31,259.2",
    transform: "translate(-534.94 -104.56)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M990.52,292.61a24.39,24.39,0,0,1-10.16,2.5,24.73,24.73,0,0,1-10.55-1.92c-5.72-1.3-7.42-2.93-7.85-4.24,0,0-.08-.47-.08-.47s0,.46.08.47.93-3.29,1.39-5.46a48,48,0,0,0,.93-5.07c.13-1.46.14-2.93.15-3.83,0-1.11,0-2,0-2.71L994,271.4c-.12.67-.26,1.6-.37,2.72a23.28,23.28,0,0,0-.15,4,12.93,12.93,0,0,0,1.25,4.69l.12.24c1.1,2.12,2.09,4,2,5.24C996.5,290.7,991.46,292.32,990.52,292.61Z",
    transform: "translate(-534.94 -104.56)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M952.12,658.71c-8.2-4.18-17.43-1.46-24.73.69-8,2.35-25.74,9.4-24.16,17s20.83,10.77,30.2,11.33c5.78.34,19.37,1.16,25.57-6a12.54,12.54,0,0,0,3-8.49C962,667.37,957.85,661.64,952.12,658.71Z",
    transform: "translate(-534.94 -104.56)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1007.16,307.57l6.13,4.78c1.85,3.5,4.42,8.51,7.34,14.69.8,1.7,1.46,3.14,2.07,4.49,0,0,2.83,6.24,5.45,12.56,10.45,25.21,15.68,37.82,16.71,49.66,0,0,.34,12.9-.8,31.23-.62,9.86-1,12.53-.84,18.87.12,4.9.26,6.6.18,10.94a39.2,39.2,0,0,1-2.85,14.58c-1.33,3-2.85,6.48-5.83,6.83-2.41.28-4.56-1.6-5.56-2.6a15.73,15.73,0,0,1-4.3-5.43,24.44,24.44,0,0,1-2.24-6.85c-.53-5.27-1.21-13.35-1.51-23.11-.81-26.14,2.19-30.94-.48-46.52-.23-1.36-3.11-11.1-8.88-30.59,0,0-3.7-12.5-7.28-27.15-.09-.36-.17-.72-.29-1.22-1.16-5.1-3.44-15.1-.87-21A8,8,0,0,1,1007.16,307.57Z",
    transform: "translate(-534.94 -104.56)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1008.72,293.08a45.21,45.21,0,0,1,7.26,2.69,49.6,49.6,0,0,1,7.07,4.09l1.68,1.16,2.57,3.92c2.06,3.12,4,6.33,5.79,9.59.92,1.62,1.79,3.27,2.67,4.92s1.63,3.4,2.4,5.12l-.85-1.65c1.58,3.52,3.08,7.09,4.46,10.7l1,2.7.5,1.35.4,1.19,1.57,4.71c2.13,6.29,4.11,12.68,6,19.31a139.21,139.21,0,0,1,4.55,21.4l.28,2.94.15,3,0,1.7v1.49c0,.25,0,.24,0,.31l0,.17-.27,2.62c-.36,3.43-.83,6.8-1.31,10.16-1,6.72-2.13,13.4-3.41,20l-1.88,9.71a84.44,84.44,0,0,0-1.23,9.41c-.28,3.24-.53,6.73-1,10.16a50,50,0,0,1-2.52,10.39c-.32.84-.66,1.67-1,2.49s-.81,1.63-1.21,2.35a21.15,21.15,0,0,1-3.16,4.62,7.53,7.53,0,0,1-2.81,1.85,6.11,6.11,0,0,1-3.46.13,8.31,8.31,0,0,1-2.77-1.34,12.83,12.83,0,0,1-2.06-1.88l.13.12a18.12,18.12,0,0,1-4.48-6.32,25,25,0,0,1-1.95-7.25c-.32-4.87-.58-9.67-.79-14.5-.43-9.66-.63-19.32-.44-29,.07-4.84.29-9.67,0-14.42a59.83,59.83,0,0,0-.85-7.07c-.18-1.17-.45-2.33-.71-3.48a10.88,10.88,0,0,0-.44-1.59l-.57-1.69c-3.25-9.06-6.86-18.08-10.63-27l.21.57c-.37-.95-.3-.81-.38-1l-.18-.41-.34-.83-.7-1.66-1.37-3.31-2.8-6.61-2.81-6.64-2.86-6.67-1.45-3.52c-.48-1.19-.94-2.42-1.39-3.69a59.35,59.35,0,0,1-2.35-8.3,30.28,30.28,0,0,1-.33-11.14c.12-.59.27-1.22.43-1.82a15.12,15.12,0,0,1,.59-1.9,21.1,21.1,0,0,1,2-4.05,21.52,21.52,0,0,1,3.12-3.84,20.55,20.55,0,0,1,1.93-1.68l.51-.38.25-.19.13-.09.07-.05.12-.07.23-.13a16,16,0,0,1,8.66-1.89Zm-3.11,29a13.13,13.13,0,0,0,7.87-1.49l.21-.12.1-.06h0l0,0,.07-.07.13-.16a6.14,6.14,0,0,0,.49-.65,5.86,5.86,0,0,0,.66-1.33,2.89,2.89,0,0,0,.14-1.05c0-.15-.05-.23-.1-.27a.46.46,0,0,0-.17-.17c-.59-.07-1.32,1.21-1.75,2.85a28.79,28.79,0,0,0-.74,5.72c0,1.05,0,2.12,0,3.24s.06,2.34.12,3.37l.57,7,.78,7c.26,2.35.61,4.68.93,7l.54,3.49.27,1.74.15.86.08.44c0,.09.15.51-.14-.15l.21.57c1.69,9.57,3.63,19.05,5.69,28.55l.37,1.81a13.52,13.52,0,0,1,.29,1.95c.12,1.23.23,2.45.3,3.68a72.76,72.76,0,0,1,.14,7.38c-.14,4.91-.7,9.7-1,14.51a206.48,206.48,0,0,0,0,28.9c.33,4.8.82,9.63,1.46,14.37a21.24,21.24,0,0,0,2.34,6.51,14.41,14.41,0,0,0,4.35,5h0l.13.11a6.7,6.7,0,0,0,3.49,1.84,2.58,2.58,0,0,0,2.5-1.34,15.49,15.49,0,0,0,1.77-3.89c.27-.79.51-1.49.69-2.21s.35-1.47.5-2.2a34.15,34.15,0,0,0,.5-4.52,44,44,0,0,0-.09-4.59l-.21-2.35-.26-2.37-.7-4.86c-.48-3.26-.9-6.88-1.11-10.34l-.6-10c-.42-6.54-1-13-1.71-19.47-.35-3.22-.76-6.43-1.17-9.59l-.33-2.32,0-.14s0-.14,0,0,0,.05,0,0l-.13-.38-.23-.76-.58-1.85-.65-1.91c-.92-2.55-2.06-5.19-3.33-7.91s-2.6-5.5-4-8.32c-2.8-5.67-5.84-11.45-8.74-17.34l-2.21-4.41-2-3.83c-1.24-2.44-2.36-4.91-3.41-7.43l-.85-1.65c-.73-1.51-1.38-3-2.09-4.57s-1.44-3.07-2.11-4.63c-1.36-3.11-2.63-6.27-3.76-9.52l4.25,5.08a2.59,2.59,0,0,0,1-.7A5.39,5.39,0,0,0,1005.61,322.06Z",
    transform: "translate(-534.94 -104.56)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 495.11,
    cy: 383.56,
    r: 12.85
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1002.9,240.91c-2.6,16.42-3.9,24.64-9,29.48-3.86,3.63-9.12,3.18-19.63,2.27-9.72-.84-16-1.51-19.35-7.87a26.51,26.51,0,0,1-2.78-11.43,39.32,39.32,0,0,1,.83-8.15c1.09-6.18,2-6.1,2.72-11.08.47-3.44.46-7.06.61-10,.24-4.75.15-4.84.56-5.89,4.06-10.35,17.49-14.44,27.17-13.45,3.29.33,15.37,1.57,19.89,12.73C1006,222.63,1004.82,228.82,1002.9,240.91Z",
    transform: "translate(-534.94 -104.56)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 945.75,
    y: 188.36,
    width: 59.9,
    height: 35.38,
    rx: 17.69,
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -495.73, -241.2)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1016,214.52c.08,2.21-1.6,6.88-4.87,16.22-2.47,7-3.21,8.33-4.47,8.74-4,1.32-9.17-7.84-10.45-10.1-2.22-4-4.24-7.55-4.36-12.63-.2-8.28,4.69-19.28,11.37-19.9S1015.56,204.15,1016,214.52Z",
    transform: "translate(-534.94 -104.56)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 1005.13,
    cy: 244.64,
    rx: 10.6,
    ry: 5.4,
    transform: "translate(-66.08 1024.71) rotate(-72.45)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1054.76,655.08c-8.87-2.46-17.37,2-24.09,5.62-7.33,3.9-23.33,14.37-20.26,21.52s22.56,6.37,31.86,5c5.72-.82,19.21-2.75,23.85-11a12.55,12.55,0,0,0,1.24-8.92C1066.14,661.59,1061,656.8,1054.76,655.08Z",
    transform: "translate(-534.94 -104.56)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M861.73,280.47c12.4,13.23,14,19.95,20.14,18.38,5.47-1.39,12.53-8.77,13.27-14.46,2-15.3-41.47-20.17-43.71-14.88C850.83,270.94,853.72,271.94,861.73,280.47Z",
    transform: "translate(-534.94 -104.56)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_02",
    "data-name": "icon 02"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M745.57,274.8l-12,21.16a1.84,1.84,0,0,0,2.1,2.69h0a1.85,1.85,0,0,1,2.27,1.29l4.78,17.33a1.83,1.83,0,0,0,2.27,1.29l26-7.15a1.86,1.86,0,0,0,1.29-2.28l-4.78-17.34a1.85,1.85,0,0,1,1.29-2.27h0a1.85,1.85,0,0,0,.43-3.39l-21.17-12A1.84,1.84,0,0,0,745.57,274.8Z",
    transform: "translate(-534.94 -104.56)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 750.6,
    y: 301.33,
    width: 11.05,
    height: 15.64,
    transform: "translate(-589.9 107.44) rotate(-15.41)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icon_10",
    "data-name": "icon 10"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 280.51,
    cy: 67.78,
    r: 15.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M831.06,174.85c0,8.63-7,29.74-15.68,29.74s-15.56-21.11-15.56-29.74",
    transform: "translate(-534.94 -104.56)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 280.51,
    cy: 68.4,
    r: 15.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M831.06,173c0,8.63-7,29.74-15.68,29.74S799.82,181.58,799.82,173",
    transform: "translate(-534.94 -104.56)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 280.51,
    cy: 68.4,
    r: 6.78
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "icon_08",
    "data-name": "icon 08"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "118.96 290.88 183.86 270.2 167.22 226.24 151.15 230.59 104.69 242.83 118.96 290.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M657.28,397.48l60.72-18a8.53,8.53,0,0,0,5.75-10.6l-10.42-35.07a8.52,8.52,0,0,0-10.67-5.72l-17.11,5.25-43.49,12.91a8.53,8.53,0,0,0-5.75,10.61l10.37,34.91A8.51,8.51,0,0,0,657.28,397.48Z",
    transform: "translate(-534.94 -104.56)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-21",
    points: "98.94 244.09 144.87 258.07 175.94 220.98"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "icon_14",
    "data-name": "icon 14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 593.75,
    y: 284.19,
    width: 40.37,
    height: 67.69,
    rx: 6.27,
    transform: "translate(-370.78 -311.65) rotate(22.03)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 603.82,
    y: 295.44,
    width: 21.71,
    height: 41.55,
    transform: "translate(-371.41 -312.06) rotate(22.03)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 65.12,
    y1: 236.88,
    x2: 72.7,
    y2: 239.95
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "icon_12",
    "data-name": "icon 12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M724.43,251.27l67.84-38a5.07,5.07,0,0,0,2-6.89L770.5,164a5.07,5.07,0,0,0-6.94-1.92L742.85,174l-47,26.32a5.06,5.06,0,0,0-2,6.89l23.62,42.16A5.06,5.06,0,0,0,724.43,251.27Z",
    transform: "translate(-534.94 -104.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M781.38,217.73l-7.8,15a5.07,5.07,0,0,1-8.92.14h0a5.06,5.06,0,0,0-6.89-1.94l-34,19.06a5.07,5.07,0,0,1-6.9-1.94L693.22,205.9a5.06,5.06,0,0,1,1.94-6.89l47-26.31,20.71-11.85a5.06,5.06,0,0,1,6.93,1.92l23.72,42.36a5.06,5.06,0,0,1-1.94,6.89l-10.19,5.71",
    transform: "translate(-534.94 -104.56)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 196.95,
    y1: 110.78,
    x2: 235.29,
    y2: 89.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 204.24,
    y1: 123.8,
    x2: 242.58,
    y2: 102.33
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformaciondecontactoCenfotec);
export default __webpack_public_path__ + "static/media/InformaciondecontactoCenfotec.9b29646557bed6b434d2c4f8b716b025.svg";
export { ForwardRef as ReactComponent };